export default function getFactsheetLink(code?: string) {
  const { protocol, host } = window.location;
  return code ? `${protocol}//${host}/${code}` : window.location.href;
}
